import React, { useEffect } from "react";
import { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../Enums/Tranlate";
import BannerService from "../../../../services/BannerService";
import { toast } from "react-toastify";
import BaseService from "../../../../services/BaseService";
import { AvField, AvForm } from "availity-reactstrap-validation";
import LoaderImg from "../../../common/LoaderImg";

const Banner = () => {
	const initial = {
		title_en: "",
		name_ar: "",
		description_en: "",
		description_ar: "",
		image: "",
		loading: false,
	};
	const [formData, setFormData] = useState([initial]);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const bannerService = new BannerService();

	useEffect(() => {
		bannerService.getList().then((res) => {
			if (res?.status === 200 && !!res?.data?.data?.data?.length) {
				setFormData(res?.data?.data?.data);
			} else {
				setFormData([initial]);
			}
		});
	}, [shouldUpdate]);

	const submit = (e) => {
		e.preventDefault();
		if (formData?.some((res) => !res?.image)) {
			toast.error("Upload Image");
			return;
		}
		let data = {
			banners: formData?.map((res) => ({
				title_en: res?.title_en,
				title_ar: res?.title_ar,
				description_en: res?.description_en,
				description_ar: res?.description_ar,
				image: res?.image,
			})),
		};

		setLoading(true);
		bannerService.create(data).then((res) => {
			if (!!res.status) {
				toast.success(res?.data?.message);
			}
			setLoading(false);
		});
	};

	const fileHandler = (e, index) => {
		let filesAll = e.target.files;
		const filesData = Object.values(filesAll);

		if (!filesData?.length) {
			return;
		}
		setFormData((prev) =>
			prev.map((res, ind) => (index === ind ? { ...res, loading: true } : res))
		);
		new BaseService().postUpload(filesData[0]).then((res) => {
			if (res?.data?.status) {
				setFormData((prev) =>
					prev.map((response, ind) =>
						index === ind
							? { ...response, image: res.data.url, loading: false }
							: response
					)
				);
			} else {
				setFormData((prev) =>
					prev.map((res, ind) =>
						index === ind ? { ...res, oading: false } : res
					)
				);
			}
		});
	};

	const handlerInput = (name, value, index) => {
		setFormData((prev) =>
			prev?.map((res, ind) => (ind === index ? { ...res, [name]: value } : res))
		);
	};
	return (
		<div>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				{formData?.map((res, index) => {
					return (
						<Row>
							{index > 0 && (
								<Col md={12} className="d-flex justify-content-end">
									<i
										className="la la-times"
										onClick={() =>
											setFormData((prev) =>
												prev?.filter((_, ind) => index !== ind)
											)
										}
										style={{
											background: "var(--danger)",
											color: "#FFF",
											cursor: "pointer",
											borderRadius: "50%",
											padding: "5px",
											fontWeight: "600",
										}}
									/>
								</Col>
							)}
							{/* Name En */}
							<Col md={6}>
								<label className="text-label">
									{Translate[lang]?.english_title}
								</label>
								<AvField
									type="text"
									placeholder={Translate[lang]?.english_title}
									bsSize="lg"
									name={`title_en_${index}`}
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={res.title_en}
									onChange={(e) =>
										handlerInput("title_en", e.target.value, index)
									}
								/>
							</Col>
							{/* Name Ar */}
							<Col md={6}>
								<label className="text-label">
									{Translate[lang]?.arabic_title}
								</label>
								<AvField
									type="text"
									placeholder={Translate[lang]?.arabic_title}
									bsSize="lg"
									name={`title_ar_${index}`}
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={res.title_ar}
									onChange={(e) =>
										handlerInput("title_ar", e.target.value, index)
									}
								/>
							</Col>
							{/* Description En */}
							<Col md={6}>
								<label className="text-label">
									{Translate[lang]?.english_description}
								</label>
								<AvField
									type="textarea"
									placeholder={Translate[lang]?.english_description}
									bsSize="lg"
									name={`description_en_${index}`}
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={res.description_en}
									onChange={(e) =>
										handlerInput("description_en", e.target.value, index)
									}
								/>
							</Col>
							{/* Description Ar */}
							<Col md={6}>
								<label className="text-label">
									{Translate[lang]?.arabic_description}
								</label>
								<AvField
									type="textarea"
									placeholder={Translate[lang]?.arabic_description}
									bsSize="lg"
									name={`description_ar_${index}`}
									validate={{
										required: {
											value: true,
											errorMessage: Translate[lang].field_required,
										},
									}}
									value={res.description_ar}
									onChange={(e) =>
										handlerInput("description_ar", e.target.value, index)
									}
								/>
							</Col>
							{/* Image */}
							<Col md={6}>
								<label className="text-label mb-0">
									{Translate[lang].image}
								</label>
								<div className="upload">
									<input
										type="file"
										name="image"
										id="image"
										onChange={(e) => fileHandler(e, index)}
									/>
									<p>{Translate[lang].upload_image}</p>
									{res?.loading ? (
										<LoaderImg />
									) : !res?.image ? (
										<svg
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M16.44 8.9C20.04 9.21 21.51 11.06 21.51 15.11V15.24C21.51 19.71 19.72 21.5 15.25 21.5H8.73998C4.26998 21.5 2.47998 19.71 2.47998 15.24V15.11C2.47998 11.09 3.92998 9.24 7.46998 8.91"
												stroke="#0F50A6"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M12 15V3.62"
												stroke="#0F50A6"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
											<path
												d="M15.35 5.85L12 2.5L8.65002 5.85"
												stroke="#0F50A6"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</svg>
									) : (
										<svg
											width="24"
											height="24"
											viewBox="0 0 16 16"
											fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<path
												d="M8 1.33333C4.32667 1.33333 1.33334 4.32667 1.33334 8C1.33334 11.6733 4.32667 14.6667 8 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32667 11.6733 1.33333 8 1.33333ZM11.1867 6.46667L7.40667 10.2467C7.31334 10.34 7.18667 10.3933 7.05334 10.3933C6.92 10.3933 6.79334 10.34 6.7 10.2467L4.81334 8.36C4.62 8.16667 4.62 7.84667 4.81334 7.65333C5.00667 7.46 5.32667 7.46 5.52 7.65333L7.05334 9.18667L10.48 5.76C10.6733 5.56667 10.9933 5.56667 11.1867 5.76C11.38 5.95333 11.38 6.26667 11.1867 6.46667Z"
												fill="#21AA37"
											/>
										</svg>
									)}
								</div>
								{!!res?.image && (
									<img
										src={res?.image}
										alt="category"
										className="mt-3 w-75 border-radius-10"
									/>
								)}
							</Col>
							<Col md={12} className="my-3">
								<hr style={{ borderColor: "#000" }} />
							</Col>
						</Row>
					);
				})}
				<div className="d-flex justify-content-between">
					<Button
						variant="outline-primary"
						onClick={() => setFormData((prev) => [...prev, initial])}
						type="button">
						{Translate[lang]?.add_new_value}
					</Button>
					<Button variant="primary" type="submit" disabled={loading}>
						{Translate[lang]?.save}
					</Button>
				</div>
			</AvForm>
		</div>
	);
};

export default Banner;
